<template lang="pug">
.flex.items-center.p-4.rounded.bg-gray-100.text-xs.font-medium(
  class="md:text-sm",
  :class="[type === 'danger' && 'bg-red-100 text-red-600', type === 'info' && 'bg-blue-50 text-blue-500']"
)
  Icon.text-3xl.self-stretch.items-center.flex.pr-4.mr-4.border-r(
    v-if="icon",
    :icon="icon",
    :class="[type === 'danger' && 'text-red-600 border-red-300', type === 'info' && 'text-blue-500 border-blue-300']"
  )
  .flex.flex-col: slot
</template>

<script>
export default {
  props: {
    type: String,
    icon: String,
  },
};
</script>